import { FormField } from "#components/ui/FormField.tsx";
import { FormFieldLabel } from "#components/ui/FormFieldLabel.tsx";
import { SmartReportCadenceRadioGroup } from "#features/smart-reports/components/SmartReportCadenceRadioGroup.tsx";
import type { UpdateSmartReportForm } from "#features/smart-reports/hooks/useUpdateSmartReportForm.ts";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Flex, Text } from "@hopper-ui/components";
import { CalendarIcon } from "@hopper-ui/icons";
import { useFormContext } from "react-hook-form";

interface SmartReportCadenceProps {
    dayOfWeek: string;
}

export const SmartReportCadence = ({ dayOfWeek }: SmartReportCadenceProps) => {
    const { tShared } = useSharedTranslation();
    const { control } = useFormContext<UpdateSmartReportForm>();

    return (
        <Flex direction="column" gap="inline-md" paddingX="inset-lg">
            <FormFieldLabel>
                <Flex
                    alignItems="center"
                    gap="inline-md"
                >
                    <Flex
                        backgroundColor="neutral-weak"
                        width="core_400"
                        height="core_400"
                        borderRadius="rounded-md"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <CalendarIcon fill="neutral" />
                    </Flex>
                    <Flex direction="column">
                        <Text fontWeight="body-md-medium">
                            {tShared("smartReports.cadenceLabel")}
                        </Text>
                        <Text color="neutral-weakest" size="xs">
                            {tShared("smartReports.cadenceDescription")}
                        </Text>
                    </Flex>
                </Flex>
            </FormFieldLabel>
            <FormField
                name="cadence"
                control={control}
                render={({ field }) => (
                    <SmartReportCadenceRadioGroup field={field} dayOfWeek={dayOfWeek} />
                )}
            />
        </Flex>
    );
};
